import { render, staticRenderFns } from "./requestCanal.vue?vue&type=template&id=7623575a"
import script from "./requestCanal.vue?vue&type=script&lang=js"
export * from "./requestCanal.vue?vue&type=script&lang=js"
import style0 from "./requestCanal.vue?vue&type=style&index=0&id=7623575a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports